import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withFirebase } from '../../../../firebase';
import { updateDiscount } from '../../../../reducers/shops';

import EditIcon from '@material-ui/icons/Edit';
import Typography from '@material-ui/core/Typography';

import Switch from '../../../../components/Switch';
import ModalComponent from './ModalForm';
import {useStyles} from './styles';

const PickupOrder = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const name = 'pickupDiscount';
    const pickupDiscount = useSelector(state => state.shops.appSettings.pickupDiscount);
    const login = useSelector(state => state.auth.login);
    const isPickupDiscount = pickupDiscount !== "0" && pickupDiscount !== undefined;
    const initialValues = { pickupDiscount };

    const [openModal, setOpenModal] = useState(false);
    const [preloader, setPreloader] = useState(false);

    const handleClose = () => setOpenModal(false);
    const handleClickSubmit = () => setOpenModal(false);
    const handleClick = () => !openModal ? setOpenModal(true) : null;

    const changeFirebase = (data) => {
        setPreloader(true);
        props.firebase.bd.ref(`${login}/settings/appSettings`)
            .update(data)
            .then(res => {
                const updateData = { name, value: data.pickupDiscount };

                updateDiscount(dispatch, updateData);
                setPreloader(false);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const changeChecker = (value) => {
        let data = {};

        !value 
            ? data.pickupDiscount = "0" 
            : data.pickupDiscount = pickupDiscount;

        const updateData = { 
            name, 
            value: data.pickupDiscount 
        };

        updateDiscount(dispatch, updateData);
        changeFirebase(data);
    }

    const onSubmit = (data) => {
        // console.log('=== Submit data ===', data);
        changeFirebase(data);
    }

    return (
        <div className={classes.order}>
            <div className={classes.orderContent}>
                <ModalComponent
                    load={preloader}
                    title="На самовывоз"
                    initialValues={initialValues}
                    open={openModal}
                    onSubmit={onSubmit} 
                    handleClose={handleClose} 
                    handleClickSubmit={handleClickSubmit} />
                <Typography className={classes.title}>На самовывоз</Typography>
                <div className={classes.orderChange}>
                    <EditIcon className={classes.editIcon} onClick={() => handleClick()} />
                    <Switch
                        disabled={!isPickupDiscount} 
                        className={classes.switchComponent} 
                        active={isPickupDiscount}
                        changeChecker={changeChecker} />
                </div>
            </div>
        </div>
    )
}

export default withFirebase(PickupOrder);